module.exports = __webpack_public_path__ + "static/img/404.0472a02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404/404.svg
// module id = pzwC
// module chunks = 1